export enum FieldHistoryTabs {
  WORK = 'work',
  CROP_PROTECTION = 'crop-protection',
  FERTILIZATION = 'fertilization',
  SEED = 'seed',
  YIELD = 'yield',
  DATA = 'data',
}
